<script lang="ts" setup>
import useApiStore from '@send-frontend/stores/api-store';

import { trpc } from '@send-frontend/lib/trpc';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useVerificationStore } from '../stores/verification-store';

const { api } = useApiStore();
const { handleSuccessfulVerificationForExistingClient } =
  useVerificationStore();
const router = useRouter();

const codeVerification = ref<string | null>(null);
const isError = ref(false);

const verifyCode = async (data: { code: string }) => {
  if (!data || !data.code) {
    console.error('Verification failed: no code provided');
    return;
  }
  codeVerification.value = data.code;
  const { id } = await handleSuccessfulVerificationForExistingClient(data.code);
  console.log('Verification successful, ID:', id);
  router.back(); // Navigate back after verification
};

const handleCodeInput = async (event: Event) => {
  const input = event.target as HTMLInputElement;
  const code = input.value.trim().replace(/\D/g, ''); // Remove non-digits
  isError.value = false;
  // Update input value to only show digits
  input.value = code;

  if (code.length === 6) {
    try {
      const response = await api.call(
        'verify',
        {
          code,
        },
        'POST'
      );

      console.log('Verification successful', response);
      if (!response) {
        isError.value = true;
      }
    } catch {
      isError.value = true;
    }
  }
};

trpc.onVerificationFinished.subscribe(
  { code: '1111' },
  {
    onData: verifyCode,
  }
);
</script>

<template>
  <h1>A new device is asking for verification</h1>
  <p>Please enter the 6-digit verification code generated by your new device</p>
  <input
    type="text"
    placeholder="Enter 6-digit verification code"
    maxlength="6"
    pattern="[0-9]{6}"
    style="
      font-family: monospace;
      font-size: 24px;
      text-align: center;
      letter-spacing: 2px;
    "
    @input="handleCodeInput"
  />
  <p v-if="codeVerification">
    New device verified. Reference ID: <strong>{{ codeVerification }}</strong>
  </p>
  <p v-if="isError" style="color: red">
    Verification failed. Please try again.
  </p>
</template>
